<template>
  <div>
    <!-- 自定义导航 -->
    <Nav></Nav>
    <!-- 自定义导航-->
    <OfficialTab></OfficialTab>
    <div class="promotion-wrap">
      <router-view></router-view>
    </div>
  </div>
</template>

<script>
import Nav from '@/components/h5/Nav.vue'
import OfficialTab from '@/components/h5/OfficialTab.vue'
export default {
  name: 'Official',
  components: {
    Nav,
    OfficialTab
  },
  mounted: function () {
  }
}
</script>

<style lang="less" scoped>
/deep/.el-table--border, /deep/.el-table--group{
  border: 1px solid #E8E8E8;
  border-radius: 4px;
}
/deep/.el-table thead,/deep/.el-table thead th{
  background: #F7F8FA;
  font-weight: normal;
  color: #666666;
}
/deep/.el-table th>.cell,/deep/.el-table td>.cell {
  font-size: 11px;
  transform: scale(0.9111111);
  -ms-transform: scale(0.9111111);	/* IE 9 */
  -moz-transform: scale(0.9111111); 	/* Firefox */
  -webkit-transform: scale(0.9111111); /* Safari 和 Chrome */
  -o-transform: scale(0.9111111);
}
/deep/.el-table tr td, /deep/.el-table th.is-leaf{
  border-bottom: 1px solid #EEEEEE;
  border-right: 0;
}
/deep/.el-table th{
  background: #F7F8FA;
}
/deep/.el-table tr:last-child td{
  border-bottom: 0;
}
/deep/.el-table tbody tr{
  color: #333333;
}
/deep/.el-table--border::after, /deep/.el-table--group::after, /deep/.el-table::before{
  width: 0;
  height: 0;
}
/deep/.el-table .cell{
  line-height: 15px;
}
/deep/.text-center{
  text-align: center;
}
/deep/.form-item .el-input__inner{
  border: 1px solid #E8E8E8;
  border-radius: 2px;
  color: #666666;
  height: 44px;
  line-height: 44px;
  font-size: 14px;
}
/deep/.van-overlay{
  background-color: rgba(0,0,0,.6);
}
/deep/ .time-input .el-input__inner{
  border: none;
  outline: none;
  background: #F7F7F7;
  height: 30px;
  line-height: 30px;
  border-radius: 2px;
}
/deep/.el-icon-times{
  background: url(../../../assets/img/h5/btn_calendar.png) center no-repeat;
  background-size: contain;
  line-height: 32px;
  width: 22px;
}
/deep/.van-popup--bottom.van-popup--round {
  border-radius: 16px 16px 0 0;
}
/deep/.van-picker__toolbar {
  margin: 6px 0;
}
/deep/ .van-picker__cancel{
  font-size: 16px;
  color: #999999;
}
/deep/ .van-picker__confirm{
  font-size: 16px;
  color: #FC3E3E;
}
/deep/ .van-picker__title{
  font-size: 18px;
  color: #666666;
}
/deep/.van-hairline--top-bottom::after, /deep/.van-hairline-unset--top-bottom::after {
  border-width: 0;
}
/deep/ .van-hairline::after{
  border: none;
}
/deep/.van-dialog__header{
  font-family: Alibaba-PuHuiTi-M;
  font-size: 18px;
  color: #222222;
}
/deep/.search-wrap{
  .search-form{
    display: flex;
    justify-content: space-between;
    flex-wrap: wrap;
    .search-item{
      width: 47.826%;
      font-size: 14px;
      margin-bottom: 10px;
      span{
        color: #222222;
      }
    }
    .search-input-item{
      background: #FFFFFF;
      border: 1px solid #E8E8E8;
      border-radius: 2px;
      padding: 8px 10px;
      .search-input{
        width: 95%;
      }
      .search-input::-webkit-input-placeholder,.ivu-input::-webkit-input-placeholder,.ivu-select-placeholder,input::-webkit-input-placeholder{
        font-family: PingFangSC-Regular;
        color: #C1C1C1;
      }
      .ivu-select-selection{
        border: none;
        height: auto;
      }
      .ivu-select-single .ivu-select-selection .ivu-select-placeholder, .ivu-select-single .ivu-select-selection .ivu-select-selected-value{
        padding:0;
        line-height: normal;
        height: auto;
      }
      .ivu-select-visible,.ivu-select-selection-focused, .ivu-select-selection:hover,.ivu-date-picker-focused input{
        border: none;
        box-shadow: none;
      }
      .search-input,.ivu-input{
        color: #222222;
      }
      input{
        border: none;
        padding: 0;
      }

      .ivu-icon-ios-arrow-down{
        content: url("../../../assets/img/btn_triangle_down.png");
        width: 22px;
        height: 22px;
        position: absolute;
        right: -8px;
      }
    }
    .search-item:last-child{
      margin-bottom: 0;
    }
    .search-box{
      width: 100%;
      .search-input,.ivu-date-picker{
        width: 45%;
      }
      .search-input:last-child,.ivu-date-picker:last-child{
        padding-left: 10px;
      }
    }
    .date-picker{
      padding-top: 2px;
      padding-bottom: 2px;
      text-align: center;
      display: flex;
      align-items: center;
      font-size: 14px;
      color: #222222;
      .date-range{
        margin-right: 5px;
      }
      .el-col{
        position: relative;
        .clear-icon{
          right: 30px;
          position: absolute;
          width: 22px;
          top: 50%;
          transform: translateY(-50%);
          -ms-transform: translateY(-50%);	/* IE 9 */
          -moz-transform: translateY(-50%); 	/* Firefox */
          -webkit-transform: translateY(-50%); /* Safari 和 Chrome */
          -o-transform: translateY(-50%); 	/* Opera */
        }
      }
    }
  }
  .search-btn{
    margin: 25px 0;
    background: #FF8622;
    border-radius: 20px;
    font-size: 16px;
    color: #FFFFFF;
    padding: 9px 0;
    text-align: center;
    width: 100%;
  }
}
/deep/.popup-wrap{
  width: 84%;
  max-height: 80%;
  background: #FFFFFF;
  border-radius: 8px;
  .popup-box{
    font-family: Alibaba-PuHuiTi-R;
    .popup-header{
      padding: 25px 15px;
      text-align: center;
      font-family: Alibaba-PuHuiTi-M;
      font-size: 18px;
      color: #222222;
      overflow: hidden;
      position: relative;
      img{
        width: 22px;
        position: absolute;
        right: 15px;
        top: 50%;
        transform: translateY(-50%);
        -ms-transform: translateY(-50%);	/* IE 9 */
        -moz-transform: translateY(-50%); 	/* Firefox */
        -webkit-transform: translateY(-50%); /* Safari 和 Chrome */
        -o-transform: translateY(-50%); 	/* Opera */
      }
    }
    .popup-content{
      padding: 0 20px 15px;
    }
    .btn-wrap{
      background: #FF8622;
      border-radius: 20px;
      text-align: center;
      font-size: 16px;
      color: #FFFFFF;
      margin: 10px 20px 20px;
      padding: 9px 0;
    }
  }
}
</style>
<style>
.ivu-message{
  z-index: 3000 !important;
}
</style>



// WEBPACK FOOTER //
// src/views/h5/official/Index.vue